import { memo } from 'react';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { CommunityJackpotWinnerCardProps } from './CommunityJackpotWinnerCard.types';
import CommunityJackpotCard from '../../CommunityJackpotCard/CommunityJackpotCard';
import CommunityJackpotPlayer from '../../CommunityJackpotPlayer/CommunityJackpotPlayer';
import { formatNumber } from '@bonanza-social/toolkit/utils';

function CommunityJackpotWinnerCard({
  type,
  name,
  amount,
  status,
  ...rest
}: CommunityJackpotWinnerCardProps) {
  return (
    <CommunityJackpotCard {...rest}>
      <CommunityJackpotPlayer
        name={name}
        status={status}
        size="large"
        paddingVertical="space-200"
      />
      <Box flexDirection="row" alignItems="center">
        <Text
          variant="body-s"
          locKey={`milestoneWinnerCard${type}`}
          locNS="communityJackpot"
          color="darkSurfacePrimary"
          paddingRight="space-200"
        />
        <Icon
          name="bonanzaCoin"
          gradient="accentBackground"
          width="space-300"
          height="space-300"
        />
        {amount ? (
          <Text
            variant="body-s"
            gradient="darkSurfaceAccent"
            paddingLeft="space-100"
          >
            {formatNumber(amount)}
          </Text>
        ) : null}
      </Box>
    </CommunityJackpotCard>
  );
}

export default memo(CommunityJackpotWinnerCard);
